/* eslint-disable no-use-before-define */
import React, { useState, useContext, useEffect } from 'react'
import { Navigate } from 'react-router-dom'
import { Container, Typography, Button, Grid, InputBase } from '@material-ui/core'

import { StringUtils } from 'utils'
import { STRINGS } from 'consts'
import { AdminContext } from 'contexts'
import { useApiCall, useCheckFormErrors, useLogIn } from 'hooks'
import { Header, snackbar } from 'components'
import { withSnackbar } from 'hooks/useCheckFormErrors'
import { useStyleContext } from 'contexts/StyleContext/useStyleContext'

import { login } from './api'
import { LoginPayload, LoginResponse } from './types'
import { useStyles } from './styles'

const rules = {
  email: [
    {
      validate: (email: string) => StringUtils.isEmail(email),
      message: 'Debe ser un mail válido.',
    },
  ],
  password: [
    {
      validate: (password: string) => password.length >= STRINGS.PASSWORD_MIN_LENGTH,
      message: `La contra debe tener al menos ${STRINGS.PASSWORD_MIN_LENGTH} caracteres.`,
    },
  ],
}

const Login = () => {
  const classes = useStyles()

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  const { admin } = useContext(AdminContext)
  const [logIn] = useLogIn()

  const [, setLogoUrl] = useState('')

  const { style, getFromStorage, isLoadingStyle } = useStyleContext()

  useEffect(() => {
    const applyLogo = async () => {
      if (style) {
        setLogoUrl(style.storeLogoUrl)
      } else {
        const styleUpdate = await getFromStorage()
        if (styleUpdate) setLogoUrl(styleUpdate.storeLogoUrl)
      }
    }
    applyLogo()
  }, [isLoadingStyle])

  const handleChangeEmail = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value)
  }
  const handleChangePassword = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(e.target.value)
  }

  const [loginApi] = useApiCall<LoginPayload, LoginResponse>(login)

  const data = { email, password }
  const formChecks = useCheckFormErrors(data, rules)
  const checkErrors = withSnackbar(formChecks)

  const onSubmit = async () => {
    if (!checkErrors()) return
    try {
      const response = await loginApi({
        email,
        password,
      })

      const { token, user } = response
      logIn(token, user)
    } catch (err) {
      snackbar.show('Usuario o contraseña incorrectos.')
    }
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const enterKeyCode = 13
    if (e.keyCode === enterKeyCode) {
      onSubmit()
    }
  }

  if (admin) return <Navigate to="/home" replace />

  return (
    <Container className={classes.container} maxWidth={false}>
      <Header showBackButton={false} />
      <Grid container spacing={2} justify="center" alignItems="center">
        <Grid item>
          <Typography variant="h5" component="h2" className={classes.label}>
            Ingresá
          </Typography>
        </Grid>
        <Grid item container xs={12} justify="center">
          <InputBase
            className={classes.input}
            inputProps={{
              className: classes.inputInner,
            }}
            placeholder="Usuario / Mail"
            type="email"
            fullWidth
            required
            value={email}
            onChange={handleChangeEmail}
            onKeyDown={handleKeyDown}
          />
        </Grid>
        <Grid item container xs={12} justify="center">
          <InputBase
            className={classes.input}
            inputProps={{
              className: classes.inputInner,
            }}
            placeholder="Contraseña"
            type="password"
            fullWidth
            required
            value={password}
            onChange={handleChangePassword}
            onKeyDown={handleKeyDown}
          />
        </Grid>
        <Grid item container xs={12} justify="center">
          <Button
            variant="contained"
            color="primary"
            className={classes.button}
            disableElevation
            disabled={formChecks.isAnyFieldEmpty || formChecks.hasErrors}
            onClick={onSubmit}
          >
            Listo!
          </Button>
        </Grid>
      </Grid>
    </Container>
  )
}

export { Login }
